import React from 'react'

import { useAllDeliveryForecastItems } from '../../data'
import { DeliveryScheduleDetailsView } from './DeliveryScheduleDetails.view'

type Props = {
  deliveryForecastId: string
  isConfirmationActive: boolean
}

export const DeliveryScheduleDetailsContainer: React.FC<Props> = ({
  deliveryForecastId,
  isConfirmationActive,
}) => {
  const { data: deliveryForecastItems } =
    useAllDeliveryForecastItems(deliveryForecastId)

  return (
    <>
      {deliveryForecastItems?.map(item => {
        return (
          <DeliveryScheduleDetailsView
            // @ts-ignore
            key={item.Id}
            deliveryForecastId={deliveryForecastId}
            //  @ts-ignore
            itemId={item.Id}
            isConfirmationActive={isConfirmationActive}
          />
        )
      })}
    </>
  )
}
